<div class="home">
  <!-- HERO : image plein écran en fondu lent, recherche centrée -->
  <section class="hero">
    <div class="hero-bg" aria-hidden="true">
      @for (img of heroImages; track img; let i = $index) {
        <img
          class="hero-img"
          [class.on]="activeSlide() === i"
          [src]="img + '-1920.webp'"
          [attr.srcset]="img + '-960.webp 960w, ' + img + '-1920.webp 1920w'"
          sizes="100vw"
          alt=""
          [attr.loading]="i === 0 ? 'eager' : 'lazy'"
          [attr.fetchpriority]="i === 0 ? 'high' : 'low'"
          decoding="async"
        />
      }
      <div class="hero-veil"></div>
    </div>

    <div class="hero-content">
      <!-- Le texte change avec l'image, en fondu doux : il s'estompe, change, puis réapparaît -->
      <div class="hero-caption" [class.hidden]="!captionVisible()">
        <span class="hero-kicker">{{ heroCaption().kicker }}</span>
        <h1 class="hero-title">{{ heroCaption().h2 }}</h1>
      </div>

      <div class="hero-search-wrap">
        <ls-search-box
          variant="hero"
          [placeholder]="'HOME.HERO.SEARCH_PLACEHOLDER' | translate"
          [ariaLabel]="'HOME.HERO.SEARCH_LABEL' | translate" />
      </div>
    </div>

    <button class="hero-scroll" type="button" [attr.aria-label]="'HOME.HERO.SCROLL' | translate" (click)="scrollToContent()">
      <i class="ls-chevron-down"></i>
    </button>
  </section>

  <!-- CHARTS -->
  <section class="zone">
    <div class="zone-h">
      <div class="left">
        <div class="ls-eyebrow">{{ 'HOME.CHARTS.EYEBROW' | translate }}</div>
        <h2>{{ 'HOME.CHARTS.H2' | translate }}</h2>
      </div>
      <a class="more" [routerLink]="publicRoute(routeName.Discover)">{{ 'HOME.CHARTS.CTA' | translate }}</a>
    </div>
    <ls-trending-charts />
  </section>

  <!-- HYMNALS -->
  <section class="zone" id="hymnals" style="padding: 5px 32px;">
    <div class="zone-h">
      <div class="left">
        <div class="ls-eyebrow">{{ 'HOME.HYMNALS.EYEBROW' | translate }}</div>
        <h2>{{ 'HOME.HYMNALS.H2' | translate }}</h2>
        <p class="sub">{{ 'HOME.HYMNALS.SUB' | translate }}</p>
      </div>
      <a class="more" [routerLink]="['/', lang(), 'recueils']">{{ 'HOME.HYMNALS.CTA' | translate }}</a>
    </div>
    @if (recueilsLoading()) {
      <div class="state-wrap"><span class="spinner"></span></div>
    } @else if (recueilsError()) {
      <div class="state-wrap state-error">
        <p>{{ recueilsError() }}</p>
        <button type="button" (click)="recueilService.getRecueilsActive()">{{ 'HOME.CHARTS.RETRY' | translate }}</button>
      </div>
    } @else {
      <ls-recueil-grid carousel [recueils]="recueils()" [showSigle]="false" />
    }
  </section>

  <!-- POPULAR LYRICS -->
  <section class="zone tinted" data-testid="section-popular">
    <div class="inner">
      <div class="zone-h">
        <div class="left">
          <div class="ls-eyebrow">{{ 'HOME.POPULAR.EYEBROW' | translate }}</div>
          <h2>{{ 'HOME.POPULAR.H2' | translate }}</h2>
        </div>
        <a
          class="more"
          [routerLink]="['/', lang(), 'popular']"
          data-testid="link-voir-populaires"
          >{{ 'HOME.POPULAR.CTA' | translate }}</a
        >
      </div>
      <ls-lyric-list-section mode="popular" />
    </div>
  </section>

  <!-- LATEST LYRICS -->
  <section class="zone" data-testid="section-latest">
    <div class="zone-h">
      <div class="left">
        <div class="ls-eyebrow">{{ 'HOME.LATEST.EYEBROW' | translate }}</div>
        <h2>{{ 'HOME.LATEST.H2' | translate }}</h2>
      </div>
      <a class="more" [routerLink]="['/', lang(), 'recents']" data-testid="link-voir-recents"
        >{{ 'HOME.LATEST.CTA' | translate }}</a
      >
    </div>
    <ls-lyric-list-section mode="latest" />
  </section>

  <!-- AUDIENCE TRIPTYCH -->
  @if (!isConnected()) {
  <section class="zone tinted" id="audience">
    <div class="inner">
      <div class="zone-h">
        <div class="left">
          <div class="ls-eyebrow">{{ 'HOME.AUDIENCE.EYEBROW' | translate }}</div>
          <h2>{{ 'HOME.AUDIENCE.H2' | translate }}</h2>
          <p class="sub">{{ 'HOME.AUDIENCE.SUB' | translate }}</p>
        </div>
      </div>
      <div class="triptych">
        @for (card of audienceCards(); track card.h3) {
          <div [class]="card.cssClass">
            <div class="pictogram">
              <i [class]="card.icon"></i>
            </div>
            <h3>{{ card.h3 }}</h3>
            <p class="desc">{{ card.desc }}</p>
            <ul class="features">
              @for (f of card.features; track f) { <li>{{ f }}</li> }
            </ul>
            <a class="cta" [routerLink]="['/', lang(), card.ctaSegment]">{{ card.cta }}</a>
          </div>
        }
      </div>
    </div>
  </section>

  <!-- SHOWCASE MODES -->
  <section class="zone">
    <div class="showcase">
      <div class="showcase-text">
        <div class="label">{{ 'HOME.SHOWCASE.LABEL' | translate }}</div>
        <h2 [innerHTML]="'HOME.SHOWCASE.H2' | translate"></h2>
        <p>{{ 'HOME.SHOWCASE.P' | translate }}</p>
        <div class="modes">
          @for (mode of showcaseModes(); track mode.nm) {
            <div class="mode">
              <div class="ic">
                <i [class]="mode.icon"></i>
              </div>
              <div>
                <div class="nm">{{ mode.nm }}</div>
                <div class="sub">{{ mode.sub }}</div>
              </div>
              @if (!mode.shortcut.startsWith('⌘')) {
                <span class="shortcut">{{ mode.shortcut }}</span>
              }
            </div>
          }
        </div>
        <div class="cta-row">
          <a class="btn primary" [routerLink]="['/', lang(), 'onboarding']">{{ 'HOME.SHOWCASE.CTA_PRIMARY' | translate }}</a>
          <a class="btn ghost" [routerLink]="['/', lang(), 'onboarding']">{{ 'HOME.SHOWCASE.CTA_GHOST' | translate }}</a>
        </div>
      </div>
      <div class="stage-mock" aria-hidden="true">
        <span class="corner">Mode karaoké · 1:27 / 4:32</span>
        <div class="lvs">
          <span class="l1">Tout sa m ye, mwen ba ou tout</span>
          <span class="l2"><span class="h">Senyè, ou se tout pou mwen</span></span>
          <span class="l3">Adorasyon mwen, se pou ou</span>
        </div>
        <div class="progress"></div>
      </div>
    </div>
  </section>

  <!-- LYRIC PEEK -->
  <section class="zone tinted">
    <div class="inner">
      <div class="peek">
        <div class="peek-lyrics">
          <div class="header">
            <div class="cover"></div>
            <div>
              <div class="ti">L'Éternel, mon berger</div>
              <div class="ar">Cantiques Spéciaux</div>
            </div>
            <div class="play">
              <i class="ls-play"></i>
            </div>
          </div>
          <div class="section">Verse 1</div>
          <span class="line">Sur les chemins de ma vie, je marche sans effroi,</span>
          <span class="line">L'Éternel est mon berger,</span>
          <span class="line">il veille sur moi.</span>
          <span class="line active">Dans les verts pâturages,</span>
          <span class="line active">il me fait reposer,</span>
          <span class="line">Près des eaux paisibles,</span>
          <span class="line">il vient me guider.</span>
          <div class="section">Choeur</div>
          <span class="line"
            ><span class="ch">Am</span><span class="annot">Il restaure mon âme</span>,
            <span class="ch">G/B</span>il éclaire ma voie,</span
          >
          <span class="line"
            >Dans la vallée sombre <span class="ch">C</span>je n'ai pas
            <span class="ch">F</span>peur du froid</span
          >
        </div>
        <div class="peek-side">
          <div class="label">{{ 'HOME.PEEK.LABEL' | translate }}</div>
          <h2 [innerHTML]="'HOME.PEEK.H2' | translate"></h2>
          <p>{{ 'HOME.PEEK.P' | translate }}</p>
          <ul>
            @for (f of peekFeatures(); track f.b) {
              <li>
                <span class="dot"></span>
                <div><b>{{ f.b }}</b> {{ f.text }}</div>
              </li>
            }
          </ul>
          <a class="peek-cta" [routerLink]="['/', lang(), 'Discover']">{{ 'HOME.PEEK.CTA' | translate }}</a>
        </div>
      </div>
    </div>
  </section>

  <!-- NUMBERS -->
  <section class="zone tinted">
    <div class="inner">
      <div class="zone-h">
        <div class="left">
          <div class="ls-eyebrow">{{ 'HOME.NUMBERS.EYEBROW' | translate }}</div>
          <h2>{{ 'HOME.NUMBERS.H2' | translate }}</h2>
        </div>
      </div>
      <div class="numbers">
        @for (num of numbers(); track num.n) {
          <div class="col">
            <div class="n">
              {{ num.n }}<span class="unit">{{ num.unit }}</span>
            </div>
            <div class="l" [innerHTML]="num.l"></div>
          </div>
        }
      </div>
    </div>
  </section>

  <!-- PREMIUM TEASER
  <section class="zone" id="premium">
    <div class="premium">
      <div>
        <div class="label">{{ 'HOME.PREMIUM.LABEL' | translate }}</div>
        <h2 [innerHTML]="'HOME.PREMIUM.H2' | translate"></h2>
        <p>{{ 'HOME.PREMIUM.P' | translate }}</p>
        <div class="cta">
          <a class="btn" [routerLink]="['/', lang(), 'premium']">{{ 'HOME.PREMIUM.CTA' | translate }}</a>
          <span class="price" [innerHTML]="'HOME.PREMIUM.PRICE' | translate"></span>
        </div>
      </div>
      <div class="features">
        @for (f of premiumFeatures(); track f.title) {
          <div class="f">
            <b>{{ f.title }}</b
            ><br />{{ f.sub }}
          </div>
        }
      </div>
    </div>
  </section>-->

  <!-- COMMUNITY -->
  <section class="zone tinted">
    <div class="inner community">
      <div class="zone-h zone-h--center">
        <div class="left" style="text-align: center; margin: 0 auto">
          <div class="ls-eyebrow">{{ 'HOME.COMMUNITY.EYEBROW' | translate }}</div>
          <h2 [innerHTML]="'HOME.COMMUNITY.H2' | translate"></h2>
        </div>
      </div>
      <p class="lede">{{ 'HOME.COMMUNITY.LEDE' | translate }}</p>
      <div class="community-grid">
        @for (av of communityAvatars; track av.initials) {
          <div class="contrib" [style]="'--c1:' + av.c1 + ';--c2:' + av.c2">{{ av.initials }}</div>
        }
        <div class="contrib more">+1 195</div>
      </div>
      <div class="community-cta">
        <a class="btn primary" [routerLink]="['/', lang(), 'onboarding']">{{ 'HOME.COMMUNITY.CTA_PRIMARY' | translate }}</a>
        <a class="btn ghost" [routerLink]="['/', lang(), 'onboarding']">{{ 'HOME.COMMUNITY.CTA_GHOST' | translate }}</a>
      </div>
    </div>
  </section>

  }

  <!-- FINAL CTA : invitation à créer un compte, inutile pour un utilisateur connecté -->
  @if (!isConnected()) {
  <section class="final-cta">
    <span class="label">{{ 'HOME.FINAL_CTA.LABEL' | translate }}</span>
    <h2>{{ 'HOME.FINAL_CTA.H2' | translate }}</h2>
    <p>{{ 'HOME.FINAL_CTA.P' | translate }}</p>
    <div class="btn-row">
      <a class="btn primary" [routerLink]="['/', lang(), ]">{{ 'HOME.FINAL_CTA.CTA_PRIMARY' | translate }}</a>
      <a class="btn ghost" [routerLink]="['/', lang(), 'Discover']">{{ 'HOME.FINAL_CTA.CTA_GHOST' | translate }}</a>
    </div>
  </section>
  }
</div>
